import {
  InternationalTargets,
  NationalTargets,
  SBTiTargets,
} from "@components/Trajectory";
import {
  Accordion,
  Button,
  CardBackground,
  Typography,
} from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import UpsellModalTrajectory from "@/components/Trajectory/UpsellModalTrajectory";

function TrajectoryContext() {
  const { t } = useTranslation(["common", "trajectory"]);
  const location = useLocation();

  const isTrajectoryCreation = location.pathname.includes("/creation");

  const areAccordionsFullWidth = isTrajectoryCreation;
  const showNavigation = isTrajectoryCreation;

  return (
    <CardBackground>
      <Typography as="h1" step="2" weight="bold">
        {t("trajectory:pedagogy.title")}
      </Typography>
      <Typography className="mb-lg mt-xs">
        {t("trajectory:pedagogy.text")}
      </Typography>
      <Accordion
        items={[
          {
            trigger: t("trajectory:pedagogy.targets.international.title"),
            content: (
              <InternationalTargets fullWidth={areAccordionsFullWidth} />
            ),
          },
          {
            trigger: t("trajectory:pedagogy.targets.national.title"),
            content: <NationalTargets fullWidth={areAccordionsFullWidth} />,
          },
          {
            trigger: t("trajectory:pedagogy.targets.sbti.title"),
            content: <SBTiTargets fullWidth={areAccordionsFullWidth} />,
          },
        ]}
      />
      {showNavigation && (
        <div className="mt-xl gap-x-md flex justify-center">
          <Button
            as={Link}
            to="/trajectory/creation/introduction"
            shape="outline"
          >
            {t("common:back")}
          </Button>
          <UpsellModalTrajectory>
            <Button as={Link} to="/trajectory/creation/projections">
              {t("common:continue")}
            </Button>
          </UpsellModalTrajectory>
        </div>
      )}
    </CardBackground>
  );
}

export default TrajectoryContext;
